import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';

import { CostCenter } from '@work4all/models/lib/Classes/CostCenter.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OwnBankDetailsCell } from '../../../containers/mask-overlays/mask-overlay/views/components/table-cells/OwnBankDetailsCell';
import {
  EditTableColumns,
  EditTableEntry,
} from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import {
  EditableEntityTable,
  TableFunctions,
} from '../editable-entity-table/EditableEntityTable';

const COSTCENTER_DATA: CostCenter = {
  id: null,
  name: null,
  number: null,
  lastNumber: null,
  disabled: null,
  additive: null,
  bankDetails: {
    id: null,
    iban: null,
    name: null,
  },
  bankDetailsId: null,
};

const newEntryMandatoryFields: (keyof CostCenter)[] = ['name', 'number'];

export const CostCenterTable = () => {
  const { t } = useTranslation();

  const [tableFunctions, setTableFunctions] =
    useState<TableFunctions<CostCenter>>(null);

  const cols = useMemo<EditTableColumns<CostCenter>[]>(
    () => [
      {
        Header: t('COMMON.NUMBER'),
        accessor: 'number',
        type: 'number',
        width: 120,
        numberCellProps: {
          showThousandsSeparator: false,
        },
      },
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 300,
        type: 'text',
      },
      {
        Header: t('COMMON.COSTCENTER.LAST_NUMBER'),
        accessor: 'lastNumber',
        width: 120,
        type: 'number',
        numberCellProps: {
          showThousandsSeparator: false,
        },
      },
      {
        Header: t('COMMON.COSTCENTER.ADDITIVE'),
        accessor: 'additive',
        width: 300,
        type: 'text',
      },
      {
        Header: t('INPUTS.BANK_DETAILS'),
        accessor: 'bankDetails',
        width: 300,
        type: 'text',
        render: (cell: Cell<CostCenter & EditTableEntry>) => {
          return (
            <OwnBankDetailsCell
              value={cell.value}
              onChange={(bank) => {
                tableFunctions?.handleEdit({
                  position: {
                    id: cell.row.original.id,
                    // @ts-expect-error TECH_DEBT
                    localId: cell.row.original.id,
                    bankDetails: bank || null,
                    bankDetailsId: bank?.id || null,
                  },
                });
              }}
            />
          );
        },
      },
      {
        Header: t('COMMON.COSTCENTER.DISABLED'),
        accessor: 'disabled',
        width: 100,
        type: 'checkbox',
      },
    ],
    [t, tableFunctions]
  );

  return (
    <EditableEntityTable<CostCenter>
      columns={cols}
      dataFields={COSTCENTER_DATA}
      entity={Entities.costCenter}
      idType="number"
      sortByField="number"
      newEntryMandatoryFields={newEntryMandatoryFields}
      onInit={setTableFunctions}
    />
  );
};
